// Libraries
var React = require('react');
var indicator = require('ordinal/indicator');

// Styles
require('./Slide.scss');

// Components
var InlineShare = require('../InlineShare/InlineShareModule');

class Slide extends React.Component {

	getSubstitutionText

	getSharingText = (event) => {
		if(this.type === "goal") {
			return "It's a goal for " + event.TeamName + "! " + event.Player.FullName + " in the " + event.Minute + indicator(event.Minute) + " minute.";
		} else if(this.type === "yellowcard") {
			return "It's a yellow card for " + event.Player.FullName + " in the " + event.Minute + indicator(event.Minute) + " minute.";
		} else if(this.type === "redcard") {
			return "It's a red card for " + event.Player.FullName + " in the " + event.Minute + indicator(event.Minute) + " minute.";
		} else if(this.type === "substitution") {

			if(this.props.event.Player && this.props.event.PlayerOn)
			{			
				return "A substitution change for " + event.TeamName + ". " + event.PlayerOn.FullName + " has replaced " + event.Player.FullName + " in the " + event.Minute + indicator(event.Minute) + " minute.";
			}

			if(this.props.event.Player && !this.props.event.PlayerOn)
			{			
				return "A substitution change for " + event.TeamName + " in the " + event.Minute + indicator(event.Minute) + " minute.";
			}

			if(!this.props.event.Player && this.props.event.PlayerOn)
			{			
				return "A substitution change for " + event.TeamName + ". " + event.PlayerOn.FullName + " on as replacement in the " + event.Minute + indicator(event.Minute) + " minute.";
			}

		} else {
			return "";
		}
	}

	render() {
		this.type = (this.props.event.HighlightType === "Booking" ? this.props.event.CardType : (this.props.event.HighlightType === 'PenaltyShot' ? this.props.event.Outcome : this.props.event.HighlightType)).toLowerCase();

		let displayTime = this.props.event.Minute + "'";

		let player = this.props.event.Player.FullName;

		if(this.props.event.HighlightType === "Substitution") {

			if(this.props.event.Player && this.props.event.PlayerOn)
			{			
				player = this.props.event.Player.FullName + ", replaced by " + this.props.event.PlayerOn.FullName;
			}

			if(this.props.event.Player && !this.props.event.PlayerOn)
			{			
				player = this.props.event.Player.FullName + ", replaced";
			}

			if(!this.props.event.Player && this.props.event.PlayerOn)
			{			
				player = this.props.event.PlayerOn.FullName + ", on as replacement";
			}

		}

		// TODO: Remove this check when the backend stops returning extra info in the displayName field
		let title = (this.props.event.HighlightType === 'PenaltyShot' ? '' : (displayTime + " - ")) + (this.props.event.HighlightType === "Substitution" ? "Substitution" : (this.props.event.HighlightType === 'PenaltyShot' ? this.props.event.Outcome + '!' : this.props.event.DisplayName));

		let sharing = {
			title: this.getSharingText(this.props.event),
			description: this.props.event.Comment,
			url: window.location.href.replace(window.location.search, "") + "?keymoment=" + this.props.event.Id,
			imageUrl: this.props.crestUrl
		}

		return (
			<div className="Slide" tabIndex={this.props.tabIndex}>
				<div className="Slide__wrapper">
					<div className="Slide__desktop-crest">
						<img src={this.props.crestUrl} alt="Team crest" />
					</div>
					<div className="Slide__desktop-separator"></div>
					<div className="Slide__detail-container">
						{this.props.event.HighlightType === 'PenaltyShot' &&
							<p className="Slide__penalty">Penalty shootout</p>
						}
						<p className="Slide__title">
							<span className={"Slide__title--" + (this.type)}></span>
							{title}
							{(this.props.event.HighlightType === 'Goal' && this.props.event.GoalTypeName === "Penalty") &&
								<span>&nbsp;(P)</span>
							}
						</p>
						<p className="Slide__player">{player}</p>
						{this.props.event.Comment &&
								<div className="Slide__separator"></div>
						}
						<div className="Slide__comment">
							<p>{this.props.event.Comment}</p>
							<InlineShare data={sharing} tabIndex={this.props.tabIndex} />
						</div>
					</div>
					<div className="Slide__mobile-crest">
						<img src={this.props.crestUrl} alt="Team crest" />
					</div>
				</div>
			</div>
		)
	}
}

module.exports = Slide;



// WEBPACK FOOTER //
// ./src/common/Highlights/Slide.js